import { render, staticRenderFns } from "./UserSettingsEdit.vue?vue&type=template&id=124f0eb0&"
import script from "./UserSettingsEdit.vue?vue&type=script&lang=js&"
export * from "./UserSettingsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports